<template>
  <div ref="self" class="c-dvc" :class="{
		'c-dvc--ipx': itemType == 'iphone',
		'c-dvc--ipad13': itemType == 'tablet-h',
		'c-dvc--ipad13-v': itemType == 'tablet-v'
	}">
		<div class="c-dvc__img-wrap" v-show="noSrcBoxDisplay">
			<div class="c-dvc__img-box i--pic" :class="itemIndex ? `i--pic-${itemIndex}` : ''">
				<Picture class="c-dvc__pic" :src="target.src" :coverSrc="target.coverSrc" :parallax="target.parallax == 0 ? false : true" :embedType="target.embedType" :ratio="target.ratio" :onLoad="onLoad" />
			</div>
			<svg v-if="itemType == 'iphone'" class="c-dvc__mask" viewBox="0 0 391 391" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path class="c-dvc__bezel" d="m 319 4 h -247 h -0.1831 c -11.0462 -0 -19.5815 -0 -26.4145 0.5583 c -6.9175 0.5652 -12.4419 1.7224 -17.378 4.2375 c -8.2791 4.2184 -15.0103 10.9496 -19.2287 19.2287 c -2.5151 4.9361 -3.6723 10.4605 -4.2375 17.3779 c -0.5583 6.8331 -0.5583 15.3684 -0.5583 26.4146 v 0.1831 v 247 v 0.183 c -0 11.046 -0 19.582 0.5583 26.415 c 0.5652 6.917 1.7224 12.441 4.2375 17.378 c 4.2184 8.279 10.9496 15.01 19.2287 19.228 c 4.9361 2.515 10.4605 3.673 17.378 4.238 c 6.833 0.558 15.3683 0.558 26.4144 0.558 h 0.1832 h 247 h 0.183 c 11.046 0 19.582 0 26.415 -0.558 c 6.917 -0.565 12.441 -1.723 17.378 -4.238 c 8.279 -4.218 15.01 -10.949 19.228 -19.228 c 2.515 -4.937 3.673 -10.461 4.238 -17.378 c 0.558 -6.833 0.558 -15.369 0.558 -26.415 v -0.183 v -247 v -0.1832 c 0 -11.0462 0 -19.5814 -0.558 -26.4144 c -0.565 -6.9175 -1.723 -12.4419 -4.238 -17.378 c -4.218 -8.2791 -10.949 -15.0103 -19.228 -19.2287 c -4.937 -2.5151 -10.461 -3.6723 -17.378 -4.2375 c -6.833 -0.5583 -15.369 -0.5583 -26.415 -0.5583 h -0.183 z" stroke="#171010" stroke-width="8"/>
				<path v-show="notch ? notch : target.notch == 1 ? true : false" class="c-dvc__notch" d="M89.5249 12.9817C89.1824 9.71911 87.2889 8.01191 84 8.00965V4H306.036V8.00547C305.63 8.00565 305.222 7.98703 304.818 8.01749C302.286 8.20842 300.34 10.0308 300.086 12.5374C299.935 14.0297 299.895 15.5343 299.837 17.0347C299.515 25.3135 295.717 31.4911 288.547 35.5779C285.088 37.5491 281.282 38.1988 277.34 38.1988C222.691 38.1971 168.043 38.1995 113.394 38.1882C111.891 38.188 110.376 38.1401 108.885 37.9565C100.432 36.9154 94.6045 32.357 91.2527 24.587C90.1836 22.1086 89.7739 19.4814 89.7473 16.7834C89.7349 15.5153 89.6573 14.2432 89.5249 12.9817Z" fill="#171010"/>
			</svg>
			<svg v-else-if="itemType == 'tablet-v' || itemType == 'tablet-h'" class="c-dvc__mask" viewBox="0 0 304 304" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path class="c-dvc__bezel" d="m 279.262 5 h -254.5245 l -0.1894 0 c -2.4174 -0.0001 -4.526 -0.0002 -6.2675 0.1421 c -1.8451 0.1507 -3.7138 0.4858 -5.5213 1.4068 c -2.6739 1.3624 -4.8479 3.5364 -6.2104 6.2103 c -0.921 1.8075 -1.2561 3.6762 -1.4068 5.5213 c -0.1423 1.7414 -0.1422 3.85 -0.1421 6.2674 l 0 0.1894 v 254.5257 l 0 0.189 c -0.0001 2.417 -0.0002 4.526 0.1421 6.267 c 0.1507 1.846 0.4858 3.714 1.4068 5.522 c 1.3625 2.674 3.5366 4.848 6.2104 6.21 c 1.8075 0.921 3.6761 1.256 5.5213 1.407 c 1.7416 0.142 3.8504 0.142 6.2681 0.142 h 0.1888 h 254.5245 h 0.189 c 2.418 0 4.527 0 6.268 -0.142 c 1.846 -0.151 3.714 -0.486 5.522 -1.407 c 2.674 -1.362 4.848 -3.536 6.21 -6.21 c 0.921 -1.808 1.256 -3.676 1.407 -5.521 c 0.142 -1.742 0.142 -3.851 0.142 -6.269 v -0.188 v -254.5257 v -0.1888 c 0 -2.4176 0 -4.5264 -0.142 -6.268 c -0.151 -1.8452 -0.486 -3.7138 -1.407 -5.5213 c -1.362 -2.6738 -3.536 -4.8479 -6.21 -6.2103 c -1.808 -0.921 -3.676 -1.256 -5.522 -1.4068 c -1.741 -0.1423 -3.85 -0.1422 -6.267 -0.1421 l -0.19 0 z" stroke="#171010" stroke-width="10" fill="none"/>
			</svg>
		</div>
		<div class="c-dvc__desc" :class="itemIndex ? `i--desc-${itemIndex}` : ''">
			<div class="t-h--13 t-h--11s">
				<span class="t--fak c-dvc__desc--info" v-html="target.caption"></span>
			</div>
		</div>
	</div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { ref, onBeforeUnmount, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";

export default {
  props: {
		target: {
			type: Object,
			default: null
		},
		itemType: {
			type: String,
			default: props => props.target.itemType ? props.target.itemType : "iphone"
		},
		notch: {
			type: Boolean,
			default: undefined
		},
		itemIndex: {
			type: Number,
			default: undefined
		},
		noSrcBoxDisplay: {
			type: Boolean,
			default: true
		}
	},
	components: {
		Picture
	},
  setup({ target, itemType, notch }) {
		const self = ref();
		const { state } = useStore();
		let calcBezelSize = null;

		const onLoad = () => {
			const svg = $.qs(".c-dvc__mask", self.value);
			const bezel = $.qs(".c-dvc__bezel", svg);
			const pic = $.qs(".c-dvc__pic", self.value);
			if(itemType == "iphone") {
				if($.hasClass("s--no-src", pic)) pic.style.paddingTop = "216.533%";
			}
			else if(itemType == "tablet-v") {
				if($.hasClass("s--no-src", pic)) pic.style.paddingTop = "133.398%";
			}
			else if(itemType == "tablet-h") {
				if($.hasClass("s--no-src", pic)) pic.style.paddingTop = "74.9634%";
			}
			const ratio = pic.style.paddingTop.slice(0, -1) / 100;

			if(itemType == "iphone") {
				const viewboxHeight = (375 * ratio) + 16;

				// 베젤 사이즈 계산 이벤트 등록
				calcBezelSize = () => {
					setTimeout(() => {
						const bezelScale = pic.clientWidth / (375 * state.unitScale);
						self.value.style.setProperty("--bezelSize", `${bezelScale * 16}em`);
					});
				};
				calcBezelSize();
				window.addEventListener("changed.mq", calcBezelSize);
				window.removeEventListener("ready.curtain", calcBezelSize);

				$.setAttr({ viewBox: `0 0 391 ${viewboxHeight}` }, svg);
				// -391 + 247 = -144
				const dy = viewboxHeight - 144;
				$.setAttr({ d: `m 319 4 h -247 h -0.1831 c -11.0462 -0 -19.5815 -0 -26.4145 0.5583 c -6.9175 0.5652 -12.4419 1.7224 -17.378 4.2375 c -8.2791 4.2184 -15.0103 10.9496 -19.2287 19.2287 c -2.5151 4.9361 -3.6723 10.4605 -4.2375 17.3779 c -0.5583 6.8331 -0.5583 15.3684 -0.5583 26.4146 v 0.1831 v ${dy} v 0.183 c -0 11.046 -0 19.582 0.5583 26.415 c 0.5652 6.917 1.7224 12.441 4.2375 17.378 c 4.2184 8.279 10.9496 15.01 19.2287 19.228 c 4.9361 2.515 10.4605 3.673 17.378 4.238 c 6.833 0.558 15.3683 0.558 26.4144 0.558 h 0.1832 h 247 h 0.183 c 11.046 0 19.582 0 26.415 -0.558 c 6.917 -0.565 12.441 -1.723 17.378 -4.238 c 8.279 -4.218 15.01 -10.949 19.228 -19.228 c 2.515 -4.937 3.673 -10.461 4.238 -17.378 c 0.558 -6.833 0.558 -15.369 0.558 -26.415 v -0.183 v -${dy} v -0.1832 c 0 -11.0462 0 -19.5814 -0.558 -26.4144 c -0.565 -6.9175 -1.723 -12.4419 -4.238 -17.378 c -4.218 -8.2791 -10.949 -15.0103 -19.228 -19.2287 c -4.937 -2.5151 -10.461 -3.6723 -17.378 -4.2375 c -6.833 -0.5583 -15.369 -0.5583 -26.415 -0.5583 h -0.183 z` }, bezel);
			}
			else if(itemType == "tablet-v" || itemType == "tablet-h") {

				// 베젤 사이즈 계산 이벤트 등록
				calcBezelSize = () => {
					setTimeout(() => {
						const multiplier = state.cw > 1599 ? 0.64 : state.cw > 599 ? 1 : 2.62564099;
						const viewBoxWidth = (pic.clientWidth / state.unitScale * multiplier) + 20;
						const viewBoxHeight = (pic.clientHeight / state.unitScale * multiplier) + 20;
						const dx = viewBoxWidth - 304;
						const dy = viewBoxHeight - 304;

						if(254.5245 + dx < 0) return;
						$.setAttr({ viewBox: `0 0 ${viewBoxWidth} ${viewBoxHeight}` }, svg);
						$.setAttr({ d: `m ${279.262 + dx} 5 h -${254.5245 + dx} l -0.1894 0 c -2.4174 -0.0001 -4.526 -0.0002 -6.2675 0.1421 c -1.8451 0.1507 -3.7138 0.4858 -5.5213 1.4068 c -2.6739 1.3624 -4.8479 3.5364 -6.2104 6.2103 c -0.921 1.8075 -1.2561 3.6762 -1.4068 5.5213 c -0.1423 1.7414 -0.1422 3.85 -0.1421 6.2674 l 0 0.1894 v ${254.5257 + dy} l 0 0.189 c -0.0001 2.417 -0.0002 4.526 0.1421 6.267 c 0.1507 1.846 0.4858 3.714 1.4068 5.522 c 1.3625 2.674 3.5366 4.848 6.2104 6.21 c 1.8075 0.921 3.6761 1.256 5.5213 1.407 c 1.7416 0.142 3.8504 0.142 6.2681 0.142 h 0.1888 h ${254.5245 + dx} h 0.189 c 2.418 0 4.527 0 6.268 -0.142 c 1.846 -0.151 3.714 -0.486 5.522 -1.407 c 2.674 -1.362 4.848 -3.536 6.21 -6.21 c 0.921 -1.808 1.256 -3.676 1.407 -5.521 c 0.142 -1.742 0.142 -3.851 0.142 -6.269 v -0.188 v -${254.5257 + dy} v -0.1888 c 0 -2.4176 0 -4.5264 -0.142 -6.268 c -0.151 -1.8452 -0.486 -3.7138 -1.407 -5.5213 c -1.362 -2.6738 -3.536 -4.8479 -6.21 -6.2103 c -1.808 -0.921 -3.676 -1.256 -5.522 -1.4068 c -1.741 -0.1423 -3.85 -0.1422 -6.267 -0.1421 l -0.19 0 z` }, bezel);
					});
				};
				calcBezelSize();
				window.addEventListener("changed.mq", calcBezelSize);
				window.removeEventListener("ready.curtain", calcBezelSize);

				// 304 - 254.5245 = 49.4755;
				// 304 기준 254.5245;
				// 49.4755 / 2 = 24.73775;

				// const viewBoxHeight = (pic.clientHeight / state.unitScale) + 20;
				// const dy = ((pic.clientHeight / state.unitScale) - 29.475) - 254.5257;
				// const viewboxHeight = (854 * ratio) + 32;

				// // 베젤 사이즈 계산 이벤트 등록
				// calcBezelSize = () => {
				// 	setTimeout(() => {
				// 		const bezelScale = pic.clientWidth / (854 * state.unitScale);
				// 		self.value.style.setProperty("--bezelSize", `${bezelScale * 32}em`);
				// 	});
				// };
				// calcBezelSize();
				// window.addEventListener("changed.mq", calcBezelSize);
				// window.removeEventListener("ready.curtain", calcBezelSize);

				// $.setAttr({ viewBox: `0 0 886 ${viewboxHeight}` }, svg);
				// // -886 + 796.4 = -89.6
				// const dy = viewboxHeight - 89.6;
				// $.setAttr({ d: `m 845.981 8 h -805.9622 c -0.1168 0 -0.2331 0 -0.3491 0 c -3.9045 -0.0002 -7.3933 -0.0005 -10.2906 0.2834 c -3.1296 0.3066 -6.3177 0.9971 -9.3534 2.8517 c -4.406 2.6919 -7.737 6.8216 -9.7523 11.5643 c -1.3193 3.1047 -1.819 6.3388 -2.0504 9.7344 c -0.2232 3.2753 -0.2231 7.2852 -0.223 12.0945 l 0 0.2717 v ${dy} l 0 0.272 c -0.0001 4.809 -0.0001 8.819 0.223 12.094 c 0.2314 3.396 0.731 6.63 2.0504 9.735 c 2.0153 4.742 5.3463 8.872 9.7523 11.564 c 3.0357 1.854 6.2238 2.545 9.3534 2.852 c 2.8973 0.283 6.3863 0.283 10.2909 0.283 h 0.3488 h 805.9622 h 0.349 c 3.905 0 7.394 0 10.291 -0.283 c 3.129 -0.307 6.318 -0.998 9.353 -2.852 c 4.406 -2.692 7.737 -6.822 9.753 -11.564 c 1.319 -3.105 1.819 -6.339 2.05 -9.735 c 0.223 -3.275 0.223 -7.285 0.223 -12.095 v -0.271 v -${dy} v -0.2715 c 0 -4.8094 0 -8.8194 -0.223 -12.0948 c -0.231 -3.3955 -0.731 -6.6296 -2.05 -9.7343 c -2.016 -4.7426 -5.347 -8.8723 -9.753 -11.5643 c -3.035 -1.8546 -6.224 -2.5452 -9.353 -2.8517 c -2.897 -0.2838 -6.386 -0.2836 -10.291 -0.2834 l -0.349 0 z` }, bezel);
			}
			// else if(itemType == "tablet-h") {
			// 	const viewboxWidth = (854 * 1 / ratio) + 32;

			// 	// 베젤 사이즈 계산 이벤트 등록
			// 	calcBezelSize = () => {
			// 		setTimeout(() => {
			// 			const bezelScale = pic.clientHeight / (854 * state.unitScale);
			// 			self.value.style.setProperty("--bezelSize", `${bezelScale * 32}em`);
			// 		});
			// 	};
			// 	calcBezelSize();
			// 	window.addEventListener("changed.mq", calcBezelSize);
			// 	window.removeEventListener("ready.curtain", calcBezelSize);

			// 	// alert(1 / ratio);
			// 	$.setAttr({ viewBox: `0 0 ${viewboxWidth} 886` }, svg);
			// 	// -886 + 805.9622 = -80.0378
			// 	// 886-40.0189
			// 	const dx = viewboxWidth - 80.0378;
			// 	$.setAttr({ d: `m ${viewboxWidth - 40.0189} 8 h -${dx} c -0.1168 0 -0.2331 0 -0.3491 0 c -3.9045 -0.0002 -7.3933 -0.0005 -10.2906 0.2834 c -3.1296 0.3066 -6.3177 0.9971 -9.3534 2.8517 c -4.406 2.6919 -7.737 6.8216 -9.7523 11.5643 c -1.3193 3.1047 -1.819 6.3388 -2.0504 9.7344 c -0.2232 3.2753 -0.2231 7.2852 -0.223 12.0945 l 0 0.2717 v 796.4 l 0 0.272 c -0.0001 4.809 -0.0001 8.819 0.223 12.094 c 0.2314 3.396 0.731 6.63 2.0504 9.735 c 2.0153 4.742 5.3463 8.872 9.7523 11.564 c 3.0357 1.854 6.2238 2.545 9.3534 2.852 c 2.8973 0.283 6.3863 0.283 10.2909 0.283 h 0.3488 h ${dx} h 0.349 c 3.905 0 7.394 0 10.291 -0.283 c 3.129 -0.307 6.318 -0.998 9.353 -2.852 c 4.406 -2.692 7.737 -6.822 9.753 -11.564 c 1.319 -3.105 1.819 -6.339 2.05 -9.735 c 0.223 -3.275 0.223 -7.285 0.223 -12.095 v -0.271 v -796.4 v -0.2715 c 0 -4.8094 0 -8.8194 -0.223 -12.0948 c -0.231 -3.3955 -0.731 -6.6296 -2.05 -9.7343 c -2.016 -4.7426 -5.347 -8.8723 -9.753 -11.5643 c -3.035 -1.8546 -6.224 -2.5452 -9.353 -2.8517 c -2.897 -0.2838 -6.386 -0.2836 -10.291 -0.2834 l -0.349 0 z` }, bezel);
			// }
		}

		onBeforeUnmount(() => {
			window.removeEventListener("ready.curtain", calcBezelSize);
		});

    return {
			self,
			onLoad
    };
  },
};
</script>